
import React from 'react'

const Security = () => {
  return (
    <div><div><h3>Security</h3><p>Change your password here.</p></div></div>
  )
}

export default Security